module.exports = __webpack_public_path__ + "img/p1_tianxinxiaoemo.9ee2b224.jpg";